import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, DollarSign, CheckCircle2, ArrowRight } from 'lucide-react';
const creditFeatures = ['Revisión de reporte de crédito', 'Estrategia de disputa personalizada', 'Plan de mejora de puntuación y asesoramiento', 'Monitoreo continuo de crédito y actualización en cada ronda'];
const fundingFeatures = ['Personal Loans', 'Business Credit Cards', 'Credit Stacking'];
const outcomes = ['Calificas para comprar tu casa o tu carro', 'Pagas tasas de interés mucho más bajas', 'Los bancos te aprueban capital para tu negocio', 'Tu perfil llega a los +700 puntos'];
export function Services() {
  return <section id="servicios" className="bg-black py-20 md:py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-240" data-mp="q4gg9xjmhb1p">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-241" data-mp="l5mznw91h3xb" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-242" data-mp="g7278j013ojf">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-14 md:mb-16" data-id="element-243" data-mp="36c7qc9w8isop">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-244" data-mp="3q1rwtdounotk">
            La Solución
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-245" data-mp="3g1renv2pveqy">
            Dos Pilares,{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-246" data-mp="24n3zmzb6mm3n">
              Un Solo Objetivo
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-247" data-mp="1pk2u30g2u3pn">
            Optimizamos tu crédito y conseguimos el capital que necesitas, todo
            con un servicio completamente personalizado.
          </p>
        </motion.div>

        {/* What changes after working with us */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-12 md:mb-14" data-id="element-248" data-mp="1bsxv80kj9fgd">
          <p className="text-center text-xs font-semibold tracking-[0.25em] uppercase text-white/40 mb-8" data-id="element-249" data-mp="sud7mihuos7h">
            Lo que cambia cuando tu perfil está listo
          </p>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-250" data-mp="2n7uu026irj0x">
            {outcomes.map((outcome, i) => <div key={i} className="flex items-start gap-3 p-5 rounded-2xl bg-white/[0.02] border border-white/[0.06]" data-id="element-251" data-mp="2urneas69d5ui" data-mpi={i}>
                <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0 mt-0.5" strokeWidth={2} data-id="element-252" data-mp="2zo3yxce9122u" />
                <span className="text-white/70 font-light text-[15px] leading-snug" data-id="element-253" data-mp="39f8cq8s6ugw3">
                  {outcome}
                </span>
              </div>)}
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-254" data-mp="2gsnq1lmnqsyv">
          {/* Service 01 — Credit */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col p-8 md:p-10 rounded-3xl bg-gradient-to-b from-white/[0.04] to-white/[0.01] border border-white/[0.08]" data-id="element-255" data-mp="2lpw7tl3w8uzl">
            <div className="flex items-center gap-4 mb-8" data-id="element-256" data-mp="dj2flariyo4r">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center" data-id="element-257" data-mp="dknbp4thmf4q">
                <TrendingUp className="h-7 w-7 text-amber-400" strokeWidth={2} data-id="element-258" data-mp="miyyevr8gsrw" />
              </div>
              <span className="text-sm font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-259" data-mp="hil22ayzv79p">
                Servicio 01
              </span>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-260" data-mp="15a8bff07pzo8">
              Optimización de{' '}
              <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-261" data-mp="1196ith0swlv8">
                Crédito
              </span>
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-8" data-id="element-262" data-mp="1ovs0d1mxsznp">
              Revisamos tu reporte de crédito y diseñamos una estrategia
              totalmente personalizada para ti, con el objetivo de restaurarlo,
              optimizarlo y hacerlo atractivo para los bancos y demás
              instituciones financieras, para conseguir capital personal o para
              tu negocio.
            </p>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-263" data-mp="15xfnb4swn5mu">
              {creditFeatures.map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-264" data-mp="s6solcn59fqr" data-mpi={i}>
                  <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-265" data-mp="w7369mkatulg" />
                  <span className="text-white/70 font-light" data-id="element-266" data-mp="i83h8dsvjdor">{feature}</span>
                </li>)}
            </ul>

            <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent group" data-id="element-267" data-mp="n8it10xicd4m">
              Quiero optimizar mi crédito
              <ArrowRight className="h-4 w-4 text-amber-400 group-hover:translate-x-1 transition-transform" data-id="element-268" data-mp="2b60bpn1rwond" />
            </a>
          </motion.div>

          {/* Service 02 — Funding (highlighted) */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col p-8 md:p-10 rounded-3xl bg-gradient-to-b from-amber-500/[0.06] to-transparent border border-amber-500/30 shadow-2xl shadow-amber-500/5" data-id="element-269" data-mp="33tw80qnfkejm">
            <div className="flex items-center gap-4 mb-8" data-id="element-270" data-mp="1d8tpczz5tggo">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/30 flex items-center justify-center" data-id="element-271" data-mp="1i8zlascgpp4k">
                <DollarSign className="h-7 w-7 text-amber-400" strokeWidth={2} data-id="element-272" data-mp="1r2ckgc14dmz3" />
              </div>
              <span className="text-sm font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-273" data-mp="1vzullg8waxwj">
                Servicio 02
              </span>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-274" data-mp="25xir9181hpth">
              Funding{' '}
              <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-275" data-mp="6ou4aileeafc">
                Solutions
              </span>
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-8" data-id="element-276" data-mp="2dh1ifurfspd5">
              Luego de optimizar tu reporte de crédito, diseñamos estrategias
              personalizadas para conseguir el capital que necesitas, sea para
              ti personalmente o para tu negocio.
            </p>

            {/* Capital range highlight box */}
            <div className="rounded-2xl border border-amber-500/20 bg-black/40 p-6 mb-8" data-id="element-277" data-mp="1ujgucpwhxutl">
              <div className="text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-3" data-id="element-278" data-mp="1plp19sk482nt">
                Nos centramos en buscar capital que va de entre
              </div>
              <div className="flex items-baseline justify-center gap-3 whitespace-nowrap" data-id="element-279" data-mp="1zjlbmi58atkv">
                <span className="text-2xl md:text-3xl font-bold bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-280" data-mp="3f03na53r1bfm">
                  $35,000
                </span>
                <span className="text-sm font-light text-white/40" data-id="element-281" data-mp="3ii16nrpgymvy">a</span>
                <span className="text-2xl md:text-3xl font-bold bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-282" data-mp="3ik45904otoca">
                  $50,000
                </span>
                <span className="text-xs font-semibold tracking-[0.15em] text-white/40" data-id="element-283" data-mp="38ly089nl4237">
                  USD
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-284" data-mp="53my40q1hy1j">
              {fundingFeatures.map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-285" data-mp="a1g1yn3vefyn" data-mpi={i}>
                  <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-286" data-mp="3rho6i92jvkmw" />
                  <span className="text-white/70 font-light" data-id="element-287" data-mp="a1vtwheyhwj">{feature}</span>
                </li>)}
            </ul>

            <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent group" data-id="element-288" data-mp="st8xao6ewd9j">
              Quiero acceder a financiamiento
              <ArrowRight className="h-4 w-4 text-amber-400 group-hover:translate-x-1 transition-transform" data-id="element-289" data-mp="635hfyatqxng" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}